import script from "./ProjectSettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectSettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectSettingsView.vue?vue&type=style&index=0&id=6a794fe5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a794fe5"]])

export default __exports__